Shopify.ProductsDrawer = (function() {
    var config = { 
      howManyToShow: 10,
      howManyToStoreInMemory: 10, 
      wrapperId: 'recently-viewed-products', 
      templateId: 'recently-viewed-product-template',
      onComplete: null,
      viewTemplate: "grid",
      loadOn: "pdp",
      shown: 0,
      batchFetchSize: 3 // Added for configurable batch fetching
    };
  
    var productHandleQueue = [];
    var wrapper = null;
    var template = null;
    var shown = 0;
  
    var cookie = {
      configuration: {
        expires: 90,
        path: '/',
        domain: window.location.hostname
      },
      name: 'shopify_recently_viewed_drawer',
      write: function(recentlyViewed) {
        document.cookie = this.name + '=' + recentlyViewed.join(' ') + '; expires=' + (new Date(Date.now() + this.configuration.expires * 24 * 60 * 60 * 1000).toUTCString()) + '; path=' + this.configuration.path + '; domain=' + this.configuration.domain;
      },
      read: function() {
        var cookies = document.cookie.split(';').map(function(cookie) {
          return cookie.trim().split('=');
        });
        var cookieValue = cookies.find(function(c) {
          return c[0] == cookie.name;
        });
        return cookieValue ? cookieValue[1].split(' ') : [];
      },
      destroy: function() {
        document.cookie = this.name + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=' + this.configuration.path + '; domain=' + this.configuration.domain;
      },
      remove: function(productHandle) {
        var recentlyViewed = this.read();
        var position = recentlyViewed.indexOf(productHandle);
        if (position !== -1) {
          recentlyViewed.splice(position, 1);
          this.write(recentlyViewed);
        }       
      }
    };
  
    var finalize = function() {
        const ymal_loading = document.querySelector('.ymal-loading');
        if(ymal_loading != null) {
            ymal_loading.remove(); 
        }

      // If we have a callback.
      if (config.onComplete) {
        try { config.onComplete() } catch (error) { }
      }  
    };
  
    var moveAlong = function() {
      const batchSize = config.batchFetchSize || 5; // Number of products to fetch in parallel
      let productsToFetchHandles = [];

      // Prepare a batch of product handles to fetch
      while (productHandleQueue.length && productsToFetchHandles.length < batchSize && config.shown < config.howManyToShow) {
        productsToFetchHandles.push(productHandleQueue.shift()); // Shift immediately
      }

      if (productsToFetchHandles.length > 0) {
        const productPromises = productsToFetchHandles.map(function(handle) {
          return fetch(`/products/${handle}?view=${config.viewTemplate}`)
            .then(function(response) {
              if (!response.ok) {
                console.error(`Failed to fetch product ${handle}: ${response.statusText}`);
                return { handle: handle, data: null, error: true }; // Mark error
              }
              return response.text().then(function(data) {
                return { handle: handle, data: data, error: false };
              });
            })
            .catch(function(error) {
              console.error(`Fetch error for product ${handle}:`, error);
              return { handle: handle, data: null, error: true }; // Mark error
            });
        });

        Promise.all(productPromises)
          .then(function(results) {
            results.forEach(function(result) {
              if (!result.error && result.data && result.data.trim() !== '') {
                if (wrapper) { // Ensure wrapper exists
                  wrapper.insertAdjacentHTML('beforeend', result.data);
                }
                config.shown++;
              }
              // If result.error is true, the product handle was already shifted 
              // from productHandleQueue and config.shown is not incremented.
            });

            // If there are more products to show and more in queue, continue
            if (productHandleQueue.length && config.shown < config.howManyToShow) {
              moveAlong();
            } else {
              finalize();
            }
          })
          .catch(function(batchError) {
            console.error('Error processing batch of products with Promise.all:', batchError);
            finalize(); 
          });
      } else {
        // No products to fetch in this batch, or all shown
        finalize();
      }
    };
  
    return {
      resizeImage: function(src, size) {
        if (size == null) {
          return src;
        }
        if (size == 'master') {
          return src.replace(/http(s)?:/, "");
        }
        var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?/i);
        if (match != null) {
          var parts = src.split(match[0]);
          return (parts[0] + "_" + size + match[0]).replace(/http(s)?:/, "");
        } else {
          return null;
        }
      },
  
      showRecentlyViewed: function(params) {
        params = params || {};
  
        // Update defaults.
        Object.assign(config, params);
  
        // Read cookie.
        productHandleQueue = cookie.read();
  
        // Template and element where to insert.
        template = document.getElementById(config.templateId);
        wrapper = document.getElementById(config.wrapperId);
  
        // How many products to show.
        config.howManyToShow = Math.min(productHandleQueue.length, config.howManyToShow);
  
        // If we have any to show.
        if (config.howManyToShow && wrapper) {
          // Getting each product with an Ajax call and rendering it on the page.
          moveAlong();    
        }
      },
  
      getConfig: function() {
        return config;
      },
  
      clearList: function() {
        cookie.destroy();      
      },
      
      recordRecentlyViewed: function(params) {
        params = params || {};
  
        // Update defaults.
        Object.assign(config, params);
  
        // Read cookie.
        var recentlyViewed = cookie.read();
        // If we are on a product page.
        if (window.location.pathname.includes('/products/')) {
          // What is the product handle on this page.
          var productHandle = window.location.pathname.match(/\/products\/([a-z0-9\-]+)/)[1];
          // In what position is that product in memory.
          var position = recentlyViewed.indexOf(productHandle);
          // If not in memory.
          if (position === -1) {
            // Add product at the start of the list.
            recentlyViewed.unshift(productHandle);
            // Only keep what we need.
            recentlyViewed = recentlyViewed.splice(0, config.howManyToStoreInMemory);
          } else {
            // Remove the product and place it at start of list.
            recentlyViewed.splice(position, 1);
            recentlyViewed.unshift(productHandle);              
          }
          // Update cookie.
          cookie.write(recentlyViewed);
        }
      }
    };
  })();  